import { Button } from "@omni/ui/components/Button/button.component";
import { MouseEvent } from "react";

import { BlockSection } from "@/components/General/BlockSection/blockSection.container";
import { TransportServiceModal } from "@/components/Modals/TransportServiceModal/transportServiceModal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useClickTracking } from "@/utils/hooks/tracking/useClickTracking.hook";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

type Props = {
    className?: string;
    reservationToken: string;
};

export const Request = ({ className, reservationToken }: Props) => {
    const { t } = useGranite();

    const { open: openModal } = useModalRouter(ModalType.TransportService);

    const url = "#transport-service";
    const buttonText = t("checkout.transportService.buttonText");

    const { onClick } = useClickTracking({
        "button-click": {
            name: buttonText,
            targetUrl: url
        }
    });

    const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick(event);
        openModal();
    };

    return (
        <>
            <BlockSection
                className={className}
                title={t("checkout.transportService.title")}
                iconClass={"las la-truck la-4x"}
            >
                <p>{t("checkout.transportService.description")}</p>
                <Button
                    color={"light-gray"}
                    title={t("checkout.transportService.buttonText")}
                    onClick={handleOnClick}
                >
                    {t("checkout.transportService.buttonText")}
                </Button>
            </BlockSection>
            <TransportServiceModal reservationToken={reservationToken} />
        </>
    );
};
